import { Position } from "models/content/Position";
import { makeRequest, networkGlobals } from "./networkUtils";

/** put position */
export const deletePositionDO = async (ID) => {
    return makeRequest(`positions/${ID}`, {
        method: "DELETE",
    })
}

/** put position */
export const updatePositionDO = async (ID, position: Partial<Position>) => {
    return makeRequest(`positions/${ID}`, {
        method: "PUT",
        body: position
    })
}

/** post new position */
export const addNewPositionDO = async (position: Partial<Position>) => {
    return makeRequest("positions/", {
        method: "POST",
        body: position
    })
}

/** upload image */
export const uploadImageDO = async (base64, position, type) => {
    return makeRequest("positions/file/", {
        method: "POST",
        body: { base64, position, type }
    })
}



export const getPositionsDO = async (where):Promise<any> => {
    return makeRequest(`positions?where=${where}`)
}


export const getAvailablePositionsDO = async (where):Promise<any> => {
    return makeRequest(`positions/available?where=${where}`)
}
  